// Unit-system LABELS only. Per the product decision, switching Imperial<->Metric does
// NOT convert any numbers -- the stored values are already in whatever unit the user's
// site works in. This just relabels bbl<->m³, USD/bbl<->USD/m³, lb<->MT everywhere.
//
// The active system is mirrored to localStorage (source of truth is the server-side
// user preference, written here on load/change) so label helpers can be read
// synchronously anywhere without prop-drilling.

export type UnitSystem = 'imperial' | 'metric';

const KEY = 'unit_system';

export function getUnitSystem(): UnitSystem {
  try {
    return localStorage.getItem(KEY) === 'metric' ? 'metric' : 'imperial';
  } catch {
    return 'imperial';
  }
}

export function setUnitSystem(system: UnitSystem): void {
  try {
    localStorage.setItem(KEY, system === 'metric' ? 'metric' : 'imperial');
  } catch {
    /* ignore */
  }
}

export interface UnitLabels {
  volume: string;      // bbl | m³
  volumeLong: string;  // barrels | cubic meters
  mass: string;        // lb | MT
  volYear: string;     // bbl/year | m³/year
  volDay: string;      // bbl/day | m³/day
  volMonth: string;    // bbl/month | m³/month
  pricePer: string;    // USD/bbl | USD/m³
  perVol: string;      // /bbl | /m³
}

const METRIC: UnitLabels = {
  volume: 'm³', volumeLong: 'cubic meters', mass: 'MT',
  volYear: 'm³/year', volDay: 'm³/day', volMonth: 'm³/month',
  pricePer: 'USD/m³', perVol: '/m³',
};

const IMPERIAL: UnitLabels = {
  volume: 'bbl', volumeLong: 'barrels', mass: 'lb',
  volYear: 'bbl/year', volDay: 'bbl/day', volMonth: 'bbl/month',
  pricePer: 'USD/bbl', perVol: '/bbl',
};

export function unitLabels(system?: UnitSystem): UnitLabels {
  return (system || getUnitSystem()) === 'metric' ? METRIC : IMPERIAL;
}
